module.exports = __webpack_public_path__ + "fenyxRysingBackground.png";